import { render, staticRenderFns } from "./XAdminUserInfo.vue?vue&type=template&id=3d17b372&scoped=true"
import script from "./XAdminUserInfo.vue?vue&type=script&lang=js"
export * from "./XAdminUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d17b372",
  null
  
)

export default component.exports